import { Link } from 'gatsby';
import React from 'react';
import ProjectMedia from '../global/ProjectMedia';
import {
  creativeTitle,
  media,
  previousStyle,
  projectContainer,
  text,
} from './NextPrevProject.module.scss';

const NextPrevProject = ({
  title_creative,
  title_descriptive,
  client,
  projectSlug,
  hero,
  previous,
}) => {
  const video = hero?.square_video
    ? hero?.square_video
    : hero?.square_image?.localFile
    ? null // fall back to using the image
    : hero?.video_link;
  const image = hero?.square_image?.localFile
    ? hero?.square_image
    : hero?.hero_image;
  const localVideo = hero?.video_link_square_local
    ? hero?.video_link_square_local
    : hero?.square_image
    ? null
    : hero?.video_link_local
  const bgColor = hero?.background_color;
  return (
    <Link
      to={projectSlug}
      className={`fadeInEl hoverScale ${projectContainer} ${
        previous ? previousStyle : ''
      } shadowSmall `}
    >
      <div className={`${text}`}>
        <h2 className={`h6 strong`}>
          {title_creative && (
            <span className={`${creativeTitle}`}>{title_creative} </span>
          )}
          {title_descriptive}
        </h2>
        <h3 className={`h6`}>{client}</h3>
      </div>
      <div className={`${media}`}>
        <ProjectMedia
          video={video}
          image={image}
          localVideo={localVideo}
          bgColor={bgColor}
          projectSlug={projectSlug}
        />
      </div>
    </Link>
  );
};

export default NextPrevProject;
